import { render } from "./FinalResultLegals.vue?vue&type=template&id=62fed52a"
import script from "./FinalResultLegals.vue?vue&type=script&lang=js"
export * from "./FinalResultLegals.vue?vue&type=script&lang=js"
script.render = render

export default script